import update from 'immutability-helper';
import {
    CLOSE_EDIT_META_SECTION_POPUP,
    DONE_EDIT_TEXT_SECTION_POPUP,
    FETCHED_ELEMENTS,
    GET_PAGE,
    ADD_API_CALL_IN_PROGRESS,
    REMOVE_API_CALL_IN_PROGRESS,
    MOVE_SECTION,
    NEW_SECTION,
    OPEN_EDIT_META_SECTION_POPUP,
    OPEN_EDIT_TEXT_SECTION_POPUP,
    OPEN_EDIT_TEXT_SECTION_COLUMNS_SINGLE_MEDIA_POPUP,
    CLOSE_EDIT_TEXT_SECTION_COLUMNS_SINGLE_MEDIA_POPUP,
    DONE_EDIT_TEXT_SECTION_COLUMNS_SINGLE_MEDIA_POPUP,
    SAVED_PAGE,
    CLOSE_EDIT_TEXT_SECTION_POPUP,
    DELETE_SECTION_IN_PAGE_STATE,
    DONE_EDIT_META_SECTION_POPUP,
    OPEN_EDIT_MAP_SECTION_POPUP,
    CLOSE_EDIT_MAP_SECTION_POPUP,
    DONE_EDIT_MAP_SECTION_POPUP,
    OPEN_EDIT_STAFF_SECTION_POPUP,
    CLOSE_EDIT_STAFF_SECTION_POPUP,
    DONE_EDIT_STAFF_SECTION_POPUP,
    OPEN_EDIT_BLOCK_SECTION_POPUP,
    CLOSE_EDIT_BLOCK_SECTION_POPUP,
    DONE_EDIT_BLOCK_SECTION_POPUP,
    ENABLE_SECTION_IN_PAGE_STATE,
    DISABLE_SECTION_IN_PAGE_STATE,
    OPEN_EDIT_PARTNERS_SECTION_POPUP,
    CLOSE_EDIT_PARTNERS_SECTION_POPUP,
    DONE_EDIT_PARTNERS_SECTION_POPUP,
    OPEN_EDIT_OVERVIEW_SECTION_POPUP,
    CLOSE_EDIT_OVERVIEW_SECTION_POPUP,
    DONE_EDIT_OVERVIEW_SECTION_POPUP,
    UPDATE_SECTION_GROUP_IN_PAGE_STATE,
    PICK_PARENT_PAGE,
    OPEN_EDIT_REVIEWS_SECTION_POPUP,
    CLOSE_EDIT_REVIEWS_SECTION_POPUP,
    DONE_EDIT_REVIEWS_SECTION_POPUP,
    OPEN_EDIT_ITINERARY_SECTION_POPUP,
    CLOSE_EDIT_ITINERARY_SECTION_POPUP,
    DONE_EDIT_ITINERARY_SECTION_POPUP,
    UPDATE_NEW_URL_IN_THE_URL_EDIT_POPUP,
    UPDATE_NO_INDEX_IN_THE_URL_EDIT_POPUP,
    OPEN_URL_EDIT_POPUP,
    CLOSE_URL_EDIT_POPUP,
    INVALIDATE_URL_IN_THE_URL_EDIT_POPUP,
    DONE_EDIT_URL_POPUP,
    OPEN_EDIT_FORM_SECTION_POPUP,
    CLOSE_EDIT_FORM_SECTION_POPUP,
    DONE_EDIT_FORM_SECTION_POPUP,
    FETCHED_FORM_TYPES,
    OPEN_EDIT_TRIP_FORMATS_SECTION_POPUP,
    CLOSE_EDIT_TRIP_FORMATS_SECTION_POPUP,
    DONE_EDIT_TRIP_FORMATS_SECTION_POPUP,
    OPEN_EDIT_PRODUCT_SNIPPETS_SECTION_POPUP,
    CLOSE_EDIT_PRODUCT_SNIPPETS_SECTION_POPUP,
    DONE_EDIT_PRODUCT_SNIPPETS_SECTION_POPUP,
    OPEN_EDIT_INTERNAL_LINKS_SECTION_POPUP,
    CLOSE_EDIT_INTERNAL_LINKS_SECTION_POPUP,
    DONE_EDIT_INTERNAL_LINKS_SECTION_POPUP,
    OPEN_EDIT_CALL_TO_ACTION_SECTION_POPUP,
    CLOSE_EDIT_CALL_TO_ACTION_SECTION_POPUP,
    DONE_EDIT_CALL_TO_ACTION_SECTION_POPUP,
    OPEN_EDIT_NEXT_STEPS_SECTION_POPUP,
    CLOSE_EDIT_NEXT_STEPS_SECTION_POPUP,
    DONE_EDIT_NEXT_STEPS_SECTION_POPUP,
    OPEN_EDIT_REVIEW_SNIPPETS_SECTION_POPUP,
    CLOSE_EDIT_REVIEW_SNIPPETS_SECTION_POPUP,
    DONE_EDIT_REVIEW_SNIPPETS_SECTION_POPUP,
    OPEN_EDIT_FAQS_SECTION_POPUP,
    CLOSE_EDIT_FAQS_SECTION_POPUP,
    DONE_EDIT_FAQS_SECTION_POPUP,
    OPEN_EDIT_FIND_YOUR_PROJECT_SECTION_POPUP,
    CLOSE_EDIT_FIND_YOUR_PROJECT_SECTION_POPUP,
    DONE_EDIT_FIND_YOUR_PROJECT_SECTION_POPUP,
    OPEN_EDIT_LARGE_SNIPPETS_SECTION_POPUP,
    CLOSE_EDIT_LARGE_SNIPPETS_SECTION_POPUP,
    DONE_EDIT_LARGE_SNIPPETS_SECTION_POPUP,
    OPEN_EDIT_VALUE_PROPOSITION_SECTION_POPUP,
    CLOSE_EDIT_VALUE_PROPOSITION_SECTION_POPUP,
    DONE_EDIT_VALUE_PROPOSITION_SECTION_POPUP,
    OPEN_EDIT_MEET_US_SECTION_POPUP,
    CLOSE_EDIT_MEET_US_SECTION_POPUP,
    DONE_EDIT_MEET_US_SECTION_POPUP,
    OPEN_EDIT_TRIP_FORMATS_CAROUSEL_SECTION_POPUP,
    CLOSE_EDIT_TRIP_FORMATS_CAROUSEL_SECTION_POPUP,
    DONE_EDIT_TRIP_FORMATS_CAROUSEL_SECTION_POPUP,
    OPEN_EDIT_GROUP_TRIPS_BANNER_SECTION_POPUP,
    CLOSE_EDIT_GROUP_TRIPS_BANNER_SECTION_POPUP,
    DONE_EDIT_GROUP_TRIPS_BANNER_SECTION_POPUP,
    FETCHED_PAGE_VERSIONS,
    FETCHED_PAGE_VERSION,
    DELETED_PAGE_VERSION,
    UPDATED_PAGE_VERSION,
    OPEN_VIEW_PAGE_VERSION_POPUP,
    CLOSE_VIEW_PAGE_VERSION_POPUP,
    OPEN_PRODUCT_TAGOS_ID_EDIT_POPUP,
    UPDATE_PRODUCT_TAGOS_ID_EDIT_POPUP,
    CLOSE_PRODUCT_TAGOS_ID_EDIT_POPUP,
    DONE_EDIT_PRODUCT_TAGOS_ID_POPUP,
    OPEN_PAGE_TAGS_EDIT_POPUP,
    UPDATE_PAGE_TAGS_EDIT_POPUP,
    CLOSE_PAGE_TAGS_EDIT_POPUP,
    DONE_EDIT_PAGE_TAGS_POPUP,
    DISCARD_CHANGES,
    SET_PAGE_PREVIEW,
    HAS_ERROR,
    UPDATE_MULTIPLE_PAGE_TAGS,
    OPEN_PAGE_PICKER,
    CLOSE_PAGE_PICKER,
    CHANGE_SECTION_BG_COLOR,
    SET_BG_COLORS,
    UPDATE_SECTION,
    TOGGLE_SECTION_POPUP,
} from './types';

import {
    OPEN_EDIT_PROMOTIONAL_BOXES_SECTION_POPUP,
    CLOSE_EDIT_PROMOTIONAL_BOXES_SECTION_POPUP,
    DONE_EDIT_PROMOTIONAL_BOXES_SECTION_POPUP,
} from './types/promotional_boxes_types';

import shortid from 'shortid';
import _find from 'lodash/find';
import _findIndex from 'lodash/findIndex';
import {SECTION_TYPE_MAP /* SECTION_TYPE_BLOCK */} from './constants';

const INITIAL_STATE = {
    newUrl: '',
    newUrlValid: true,
    pages: {},
    apiCallsInProgress: [],
    elements: [],
    formTypes: [],
    pageVersions: [],
    pageVersion: null,
    productTagosId: null,
    tagsForDisplay: {},
    tagsForUpdate: {},
    previewLink: '',
    isPopupOpened: false,
    viewPageVersionPopup: {
        open: false,
    },
    staffSectionPopup: {
        open: false,
    },
    editUrlPopup: {
        open: false,
    },
    editProductTagosIdPopup: {
        open: false,
    },
    editPageTagsPopup: {
        open: false,
        error: {},
    },
    overviewSectionPopup: {
        open: false,
    },
    textSectionPopup: {
        open: false,
    },
    textColumnsSingleMediaSectionPopup: {
        open: false,
    },
    partnersSectionPopup: {
        open: false,
    },
    mapSectionPopup: {
        open: false,
    },
    metaSectionPopup: {
        open: false,
        error: {},
    },
    blockSectionPopup: {
        open: false,
    },
    itinerarySectionPopup: {
        open: false,
    },
    reviewsSectionPopup: {
        open: false,
    },
    formSectionPopup: {
        open: false,
    },
    tripFormatsSectionPopup: {
        open: false,
    },
    productSnippetsSectionPopup: {
        open: false,
    },
    internalLinksSectionPopup: {
        open: false,
    },
    callToActionSectionPopup: {
        open: false,
    },
    nextStepsSectionPopup: {
        open: false,
    },
    reviewSnippetsSectionPopup: {
        open: false,
    },
    faqsSectionPopup: {
        open: false,
    },
    findYourProjectSectionPopup: {
        open: false,
    },
    largeSnippetsSectionPopup: {
        open: false,
    },
    valuePropositionSectionPopup: {
        open: false,
    },
    meetUsSectionPopup: {
        open: false,
    },
    tripFormatsCarouselSectionPopup: {
        open: false,
    },
    groupTripsBannerSectionPopup: {
        open: false,
    },
    sectionPagePickerPopup: {
        open: false,
    },
    promotionalBoxesSectionPopup: {
        open: false,
    },
    bgColors: [],
};

export default function(state = INITIAL_STATE, action) {
    let pageToAlter = null;
    let newPage = null;
    let toEditSection;
    let toEditSectionPosition;

    switch (action.type) {
        case GET_PAGE:
            // if is not already in state
            // if we keep inserted data in page state, any change made to the blocks is not being updated unless the block is selected again in the section
            // also, the order of the sections is not being kept properly
            // comment this for now until we find a solution and add a message on pages that if they leave the page without saving they will lose their changes

            if (state.pages[action.payload.data.id] !== undefined) {
                return state;
                /* let blockSections = action.payload.data.sections.filter(element => element.type_id === SECTION_TYPE_BLOCK);
                let sectionsNoBlocks = state.pages[action.payload.data.id].sections.filter(element => element.type_id !== SECTION_TYPE_BLOCK);
                let allSections = sectionsNoBlocks.concat(blockSections);

                return update(state, {
                    pages: {
                        [action.payload.data.id]: {
                            $set: {
                                sections: allSections,
                                isDirty: state.pages[action.payload.data.id].isDirty,
                                meta: state.pages[action.payload.data.id].meta
                            }
                        }
                    }
                }); */
            }

            let allSections = update(action.payload.data.sections, {
                $apply: (el) =>
                    el.map((inner) => {
                        return update(inner, {
                            $merge: {
                                new: false,
                                touched: false,
                                deleted: false,
                                uniqueId: shortid.generate(),
                            },
                        });
                    }),
            });

            return update(state, {
                pages: {
                    [action.payload.data.id]: {
                        $set: {
                            sections: allSections,
                            isDirty: false,
                            meta: {
                                id: action.payload.data.id,
                                title: action.payload.data.title,
                                subheading: action.payload.data.subheading,
                                old_url: action.payload.data.old_url,
                                master: action.payload.data.master,
                                url:
                                    action.payload.data.url !== null
                                        ? action.payload.data.url
                                        : '',
                                noindex: action.payload.data.noindex,
                                preview_site_url:
                                    action.payload.data.preview_site_url,
                                preview: action.payload.data.preview,
                                product_tagos_id:
                                    action.payload.data.product_tagos_id,
                                breadcrumb_title:
                                    action.payload.data.breadcrumb_title,
                                menu_title: action.payload.data.menu_title,
                                meta_title: action.payload.data.meta_title,
                                meta_description:
                                    action.payload.data.meta_description,
                                snippet: action.payload.data.snippet,
                                is_global: action.payload.data.is_global,
                                type: action.payload.data.type_code,
                                type_id: action.payload.data.type_id,
                                destination_id:
                                    action.payload.data.destination.id,
                                locations: action.payload.data.locations,
                                has_snippet: action.payload.data.has_snippet,
                                heroImage: action.payload.data.heroImage,
                                hero_video_url:
                                    action.payload.data.hero_video_url,
                                site_id: action.payload.data.site_id,
                                site: action.payload.data.site,
                                terms: action.payload.data.terms,
                                tags: action.payload.data.tags,
                                review: action.payload.data.review
                                    ? action.payload.data.review
                                    : {},
                                custom: action.payload.data.custom
                                    ? action.payload.data.custom
                                    : {},
                                blog: action.payload.data.blog
                                    ? action.payload.data.blog
                                    : {},
                                product: action.payload.data.product
                                    ? action.payload.data.product
                                    : {},
                                parent_page: action.payload.data.parent_page
                                    ? action.payload.data.parent_page
                                    : {},
                                versions: action.payload.data.versions
                                    ? action.payload.data.versions
                                    : [],
                                team_id: action.payload.data.team_id
                                    ? action.payload.data.team_id
                                    : null,
                                has_missing_translations: action.payload.data
                                    .has_missing_translations
                                    ? action.payload.data
                                          .has_missing_translations
                                    : false,
                            },
                        },
                    },
                },
                tagsForDisplay: {
                    [action.payload.data.id]: {
                        $set: !Array.isArray(action.payload.data.tags)
                            ? action.payload.data.tags
                            : {},
                    },
                },
                tagsForUpdate: {
                    [action.payload.data.id]: {
                        $set: !Array.isArray(action.payload.data.tags)
                            ? action.payload.data.tags
                            : {},
                    },
                },
            });

        case ADD_API_CALL_IN_PROGRESS:
            return update(state, {
                apiCallsInProgress: {$push: [action.payload]},
            });

        case REMOVE_API_CALL_IN_PROGRESS:
            return update(state, {
                apiCallsInProgress: {$unshift: [action.payload]},
            });

        case MOVE_SECTION:
            pageToAlter = state.pages[action.payload.pageId];
            newPage = update(pageToAlter, {
                isDirty: {$set: true},
                sections: {
                    $splice: [
                        [action.payload.dragIndex, 1],
                        [action.payload.hoverIndex, 0, action.payload.dragCard],
                    ],
                },
            });

            return update(state, {
                pages: {[action.payload.pageId]: {$set: newPage}},
            });

        case SAVED_PAGE:
            pageToAlter = state.pages[action.payload.pageId];
            let sections = action.payload.data.sections;

            return update(state, {
                pages: {
                    [action.payload.data.id]: {
                        isDirty: {$set: false},
                        meta: {
                            $merge: {
                                heroImage: action.payload.data.heroImage,
                                url: action.payload.data.url,
                            },
                        },
                        sections: {
                            $set: sections,
                        },
                    },
                },
            });

        case DISCARD_CHANGES:
            return update(state, {
                pages: {$set: {}},
            });

        case FETCHED_ELEMENTS:
            return update(state, {
                elements: {$set: action.payload.elements},
            });

        case FETCHED_FORM_TYPES:
            return update(state, {
                formTypes: {$set: action.formTypes},
            });

        /** start page versions **/

        case FETCHED_PAGE_VERSIONS:
            return update(state, {
                pageVersions: {$set: action.pageVersions},
            });

        case FETCHED_PAGE_VERSION:
            return update(state, {
                pageVersion: {$set: action.pageVersion},
            });

        case DELETED_PAGE_VERSION:
            let allPageVersions = state.pageVersions.filter(
                (item) => item.id !== action.versionId
            );

            return update(state, {
                pageVersions: {$set: allPageVersions},
            });

        case OPEN_VIEW_PAGE_VERSION_POPUP:
            return update(state, {
                viewPageVersionPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_VIEW_PAGE_VERSION_POPUP:
            return update(state, {
                viewPageVersionPopup: {
                    open: {$set: false},
                },
            });

        case UPDATED_PAGE_VERSION:
            return update(state, {
                pageVersion: {
                    $merge: {is_current: true},
                },
                viewPageVersionPopup: {
                    open: {$set: false},
                },
            });

        /** end page versions **/

        case DONE_EDIT_MAP_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            let updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    settings: action.payload.settings,
                    locations:
                        typeof action.payload.locations !== undefined
                            ? action.payload.locations
                            : [],
                    sectionSettings: action.payload.sectionSettings,
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                mapSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        case DELETE_SECTION_IN_PAGE_STATE:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    deleted: true,
                },
            });

            return update(state, {
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        case UPDATE_SECTION_GROUP_IN_PAGE_STATE:
            pageToAlter = state.pages[action.payload.pageId];
            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    group: action.payload.group,
                },
            });

            return update(state, {
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        case ENABLE_SECTION_IN_PAGE_STATE:
            pageToAlter = state.pages[action.payload.pageId];
            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    is_visible: true,
                },
            });

            return update(state, {
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        case DISABLE_SECTION_IN_PAGE_STATE:
            pageToAlter = state.pages[action.payload.pageId];
            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    is_visible: false,
                },
            });

            return update(state, {
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        case HAS_ERROR:
            return update(state, {
                metaSectionPopup: {
                    error: {
                        $merge: {
                            [action.payload.field]: action.payload.metaError,
                        },
                    },
                },
                editPageTagsPopup: {
                    error: {
                        $merge: {
                            [action.payload.field]: action.payload.metaError,
                        },
                    },
                },
            });

        case OPEN_EDIT_META_SECTION_POPUP:
            return update(state, {
                metaSectionPopup: {
                    open: {$set: true},
                    error: {$set: {}},
                },
            });

        case PICK_PARENT_PAGE:
            return update(state, {
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        meta: {
                            $merge: {
                                parent_page: {
                                    id: action.payload.parentPageId,
                                    title: action.payload.parentPageTitle,
                                },
                            },
                        },
                    },
                },
            });

        case DONE_EDIT_META_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            let firstMapSection = _find(pageToAlter.sections, {
                type_id: SECTION_TYPE_MAP,
            });

            let firstMapSectionIndex = _findIndex(pageToAlter.sections, {
                type_id: SECTION_TYPE_MAP,
            });
            // the page does not have a map section
            if (firstMapSectionIndex >= 0) {
                let updatedFirstMapSection = update(firstMapSection, {
                    locations: {$set: action.payload.sectionLocations},
                });

                return update(state, {
                    pages: {
                        [action.payload.pageId]: {
                            isDirty: {$set: true},
                            meta: {$merge: action.payload.meta},
                            sections: {
                                [firstMapSectionIndex]: {
                                    $set: updatedFirstMapSection,
                                },
                            },
                        },
                    },
                    metaSectionPopup: {
                        open: {$set: false},
                        error: {$set: {}},
                    },
                });
            }

            return update(state, {
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        meta: {$merge: action.payload.meta},
                    },
                },
                metaSectionPopup: {
                    open: {$set: false},
                },
            });

        case CLOSE_EDIT_META_SECTION_POPUP:
            return update(state, {
                metaSectionPopup: {
                    open: {$set: false},
                    error: {$set: {}},
                },
            });

        case UPDATE_NEW_URL_IN_THE_URL_EDIT_POPUP:
            return update(state, {
                newUrl: {$set: action.payload.newUrl},
            });

        case UPDATE_NO_INDEX_IN_THE_URL_EDIT_POPUP:
            return update(state, {
                pages: {
                    [action.payload.pageId]: {
                        meta: {
                            noindex: {$set: action.payload.noindex},
                        },
                    },
                },
            });

        case OPEN_URL_EDIT_POPUP:
            return update(state, {
                newUrl: {$set: action.payload.url},
                editUrlPopup: {
                    open: {$set: true},
                },
            });

        case DONE_EDIT_URL_POPUP:
            return update(state, {
                newUrlValid: {$set: true},
                editUrlPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        meta: {
                            url: {$set: action.payload.url},
                        },
                    },
                },
            });

        case CLOSE_URL_EDIT_POPUP:
            return update(state, {
                editUrlPopup: {
                    open: {$set: false},
                },
            });

        case INVALIDATE_URL_IN_THE_URL_EDIT_POPUP:
            return update(state, {
                newUrlValid: {$set: false},
            });

        /* Start Product Tagos ID */

        case UPDATE_PRODUCT_TAGOS_ID_EDIT_POPUP:
            return update(state, {
                productTagosId: {$set: action.payload.newProductTagosId},
            });

        case OPEN_PRODUCT_TAGOS_ID_EDIT_POPUP:
            return update(state, {
                productTagosId: {$set: action.payload.productTagosId},
                editProductTagosIdPopup: {
                    open: {$set: true},
                },
            });

        case DONE_EDIT_PRODUCT_TAGOS_ID_POPUP:
            return update(state, {
                editProductTagosIdPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        meta: {
                            product_tagos_id: {
                                $set: action.payload.productTagosId,
                            },
                        },
                    },
                },
            });

        case CLOSE_PRODUCT_TAGOS_ID_EDIT_POPUP:
            return update(state, {
                editProductTagosIdPopup: {
                    open: {$set: false},
                },
            });

        /* End Product Tagos ID */

        /* Start Page Tags */

        case UPDATE_PAGE_TAGS_EDIT_POPUP:
            return update(state, {
                tagsForDisplay: {
                    [action.payload.pageId]: {
                        [action.payload.tagsKey]: {
                            $set:
                                action.payload.singlePageTags[0] !== null
                                    ? action.payload.singlePageTags
                                    : [],
                        },
                    },
                },
            });

        case UPDATE_MULTIPLE_PAGE_TAGS:
            return update(state, {
                tagsForDisplay: {
                    [action.payload.pageId]: {
                        [action.payload.tagsKey]: {
                            $set: action.payload.multiplePageTags,
                        },
                    },
                },
            });

        case OPEN_PAGE_TAGS_EDIT_POPUP:
            return update(state, {
                editPageTagsPopup: {
                    open: {$set: true},
                    error: {$set: {}},
                },
            });

        case DONE_EDIT_PAGE_TAGS_POPUP:
            return update(state, {
                editPageTagsPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        meta: {
                            tags: {
                                $set:
                                    state.tagsForDisplay[action.payload.pageId],
                            },
                        },
                    },
                },
                tagsForUpdate: {
                    [action.payload.pageId]: {
                        $set: state.tagsForDisplay[action.payload.pageId],
                    },
                },
            });

        case CLOSE_PAGE_TAGS_EDIT_POPUP:
            return update(state, {
                editPageTagsPopup: {
                    open: {$set: false},
                    error: {$set: {}},
                },
                tagsForDisplay: {$set: state.tagsForUpdate},
            });

        /* End Page Tags */

        case CLOSE_EDIT_MAP_SECTION_POPUP:
            return update(state, {
                mapSectionPopup: {
                    open: {$set: false},
                },
            });

        case OPEN_EDIT_MAP_SECTION_POPUP:
            return update(state, {
                mapSectionPopup: {
                    open: {$set: true},
                },
            });

        case NEW_SECTION:
            pageToAlter = state.pages[action.payload.pageId];

            newPage = update(pageToAlter, {
                isDirty: {$set: true},
                sections: {
                    $splice: [
                        [
                            action.payload.dropWhere + 1,
                            0,
                            {
                                id: null,
                                uniqueId: shortid.generate(),
                                type_id: action.payload.sectionTypeId,
                                section_type: action.payload.sectionType,
                                placeholder_name:
                                    action.payload.sectionType + ' Section',
                                section_text_id: 0,
                                settings: [],
                                data: {
                                    title: 'title here ...',
                                    body: 'body here ...',
                                    instructions: 'instructions here ...',
                                    images: [],
                                    locations: [],
                                },
                                new: true,
                                touched: true,
                                deleted: false,
                                is_visible: false,
                            },
                        ],
                    ],
                },
            });

            return update(state, {
                pages: {[action.payload.pageId]: {$set: newPage}},
            });

        /** start partners section **/

        case OPEN_EDIT_PARTNERS_SECTION_POPUP:
            return update(state, {
                partnersSectionPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_EDIT_PARTNERS_SECTION_POPUP:
            return update(state, {
                partnersSectionPopup: {
                    open: {$set: false},
                },
            });

        case DONE_EDIT_PARTNERS_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    settings: action.payload.settings,
                    locations:
                        typeof action.payload.locations !== undefined
                            ? action.payload.locations
                            : [],
                    block:
                        typeof action.payload.block !== undefined
                            ? action.payload.block
                            : [],
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                partnersSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** overview section **/

        case OPEN_EDIT_OVERVIEW_SECTION_POPUP:
            return update(state, {
                overviewSectionPopup: {
                    open: {$set: true},
                },
            });

        case DONE_EDIT_OVERVIEW_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    settings: action.payload.settings,
                    locations:
                        typeof action.payload.locations !== undefined
                            ? action.payload.locations
                            : [],
                    block:
                        typeof action.payload.block !== undefined
                            ? action.payload.block
                            : [],
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                overviewSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        case CLOSE_EDIT_OVERVIEW_SECTION_POPUP:
            return update(state, {
                overviewSectionPopup: {
                    open: {$set: false},
                },
            });
        /** end overview section **/

        /** reviews section **/

        case OPEN_EDIT_REVIEWS_SECTION_POPUP:
            return update(state, {
                reviewsSectionPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_EDIT_REVIEWS_SECTION_POPUP:
            return update(state, {
                reviewsSectionPopup: {
                    open: {$set: false},
                },
            });

        case DONE_EDIT_REVIEWS_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    settings: action.payload.settings,
                    locations:
                        typeof action.payload.locations !== undefined
                            ? action.payload.locations
                            : [],
                    block:
                        typeof action.payload.block !== undefined
                            ? action.payload.block
                            : [],
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                reviewsSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** end reviews section **/

        /** itinerary section **/

        case OPEN_EDIT_ITINERARY_SECTION_POPUP:
            return update(state, {
                itinerarySectionPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_EDIT_ITINERARY_SECTION_POPUP:
            return update(state, {
                itinerarySectionPopup: {
                    open: {$set: false},
                },
            });

        case DONE_EDIT_ITINERARY_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    settings: action.payload.settings,
                    locations:
                        typeof action.payload.locations !== undefined
                            ? action.payload.locations
                            : [],
                    block:
                        typeof action.payload.block !== undefined
                            ? action.payload.block
                            : [],
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                itinerarySectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** end itinerary section **/

        /** start staff section popup **/

        case OPEN_EDIT_STAFF_SECTION_POPUP:
            return update(state, {
                staffSectionPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_EDIT_STAFF_SECTION_POPUP:
            return update(state, {
                staffSectionPopup: {
                    open: {$set: false},
                },
            });

        case DONE_EDIT_STAFF_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    settings: action.payload.settings,
                    locations:
                        typeof action.payload.locations !== undefined
                            ? action.payload.locations
                            : [],
                    block:
                        typeof action.payload.block !== undefined
                            ? action.payload.block
                            : [],
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                staffSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** end staff section popup **/

        /** form section popup **/

        case OPEN_EDIT_FORM_SECTION_POPUP:
            return update(state, {
                formSectionPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_EDIT_FORM_SECTION_POPUP:
            return update(state, {
                formSectionPopup: {
                    open: {$set: false},
                },
            });

        case DONE_EDIT_FORM_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    settings: action.payload.settings,
                    locations:
                        typeof action.payload.locations !== undefined
                            ? action.payload.locations
                            : [],
                    block:
                        typeof action.payload.block !== undefined
                            ? action.payload.block
                            : [],
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                formSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** end form section popup **/

        /** trip formats section popup **/

        case OPEN_EDIT_TRIP_FORMATS_SECTION_POPUP:
            return update(state, {
                tripFormatsSectionPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_EDIT_TRIP_FORMATS_SECTION_POPUP:
            return update(state, {
                tripFormatsSectionPopup: {
                    open: {$set: false},
                },
            });

        case DONE_EDIT_TRIP_FORMATS_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    settings: action.payload.settings,
                    locations:
                        typeof action.payload.locations !== undefined
                            ? action.payload.locations
                            : [],
                    block:
                        typeof action.payload.block !== undefined
                            ? action.payload.block
                            : [],
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                tripFormatsSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** end trip formats section popup **/

        /** product snippets section popup **/

        case OPEN_EDIT_PRODUCT_SNIPPETS_SECTION_POPUP:
            return update(state, {
                productSnippetsSectionPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_EDIT_PRODUCT_SNIPPETS_SECTION_POPUP:
            return update(state, {
                productSnippetsSectionPopup: {
                    open: {$set: false},
                },
            });

        case DONE_EDIT_PRODUCT_SNIPPETS_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    settings: action.payload.settings,
                    locations:
                        typeof action.payload.locations !== undefined
                            ? action.payload.locations
                            : [],
                    block:
                        typeof action.payload.block !== undefined
                            ? action.payload.block
                            : [],
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                productSnippetsSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** end product snippets section popup **/

        /** internal links section popup **/

        case OPEN_EDIT_INTERNAL_LINKS_SECTION_POPUP:
            return update(state, {
                internalLinksSectionPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_EDIT_INTERNAL_LINKS_SECTION_POPUP:
            return update(state, {
                internalLinksSectionPopup: {
                    open: {$set: false},
                },
            });

        case DONE_EDIT_INTERNAL_LINKS_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    settings: action.payload.settings,
                    locations:
                        typeof action.payload.locations !== undefined
                            ? action.payload.locations
                            : [],
                    block:
                        typeof action.payload.block !== undefined
                            ? action.payload.block
                            : [],
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                internalLinksSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** end internal links section popup **/

        /** call to action section popup **/

        case OPEN_EDIT_CALL_TO_ACTION_SECTION_POPUP:
            return update(state, {
                callToActionSectionPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_EDIT_CALL_TO_ACTION_SECTION_POPUP:
            return update(state, {
                callToActionSectionPopup: {
                    open: {$set: false},
                },
            });

        case DONE_EDIT_CALL_TO_ACTION_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    settings: action.payload.settings,
                    locations:
                        typeof action.payload.locations !== undefined
                            ? action.payload.locations
                            : [],
                    block:
                        typeof action.payload.block !== undefined
                            ? action.payload.block
                            : [],
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                callToActionSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** end call to action section popup **/

        /** next steps section popup **/

        case OPEN_EDIT_NEXT_STEPS_SECTION_POPUP:
            return update(state, {
                nextStepsSectionPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_EDIT_NEXT_STEPS_SECTION_POPUP:
            return update(state, {
                nextStepsSectionPopup: {
                    open: {$set: false},
                },
            });

        case DONE_EDIT_NEXT_STEPS_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    settings: action.payload.settings,
                    locations:
                        typeof action.payload.locations !== undefined
                            ? action.payload.locations
                            : [],
                    block:
                        typeof action.payload.block !== undefined
                            ? action.payload.block
                            : [],
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                nextStepsSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** end next steps section popup **/

        /** review snippets section popup **/

        case OPEN_EDIT_REVIEW_SNIPPETS_SECTION_POPUP:
            return update(state, {
                reviewSnippetsSectionPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_EDIT_REVIEW_SNIPPETS_SECTION_POPUP:
            return update(state, {
                reviewSnippetsSectionPopup: {
                    open: {$set: false},
                },
            });

        case DONE_EDIT_REVIEW_SNIPPETS_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    settings: action.payload.settings,
                    locations:
                        typeof action.payload.locations !== undefined
                            ? action.payload.locations
                            : [],
                    block:
                        typeof action.payload.block !== undefined
                            ? action.payload.block
                            : [],
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                reviewSnippetsSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** end review snippets section popup **/

        /** block section popup **/

        case OPEN_EDIT_BLOCK_SECTION_POPUP:
            return update(state, {
                blockSectionPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_EDIT_BLOCK_SECTION_POPUP:
            return update(state, {
                blockSectionPopup: {
                    open: {$set: false},
                },
            });

        case DONE_EDIT_BLOCK_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            if (action.payload.block !== null) {
                updatedSection = update(toEditSection, {
                    $merge: {
                        block:
                            typeof action.payload.block !== undefined
                                ? action.payload.block
                                : [],
                        touched: true,
                        deleted: false,
                    },
                });
            } else { // when we are not updating the block, we are updating the section settings
                updatedSection = update(toEditSection, {
                    $merge: {
                        sectionSettings: action.payload.sectionSettings,
                        touched: true,
                        deleted: false,
                    },
                });
            }

            return update(state, {
                blockSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** end block section popup **/

        /** text section popup **/

        case CLOSE_EDIT_TEXT_SECTION_POPUP:
            return update(state, {
                textSectionPopup: {
                    open: {$set: false},
                },
            });

        case OPEN_EDIT_TEXT_SECTION_POPUP:
            return update(state, {
                textSectionPopup: {
                    open: {$set: true},
                },
            });

        case DONE_EDIT_TEXT_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    sectionSettings: action.payload.sectionSettings,
                    imageSettings: action.payload.imageSettings,
                    videoSettings: action.payload.videoSettings,
                    locations:
                        typeof action.payload.locations !== undefined
                            ? action.payload.locations
                            : [],
                    block:
                        typeof action.payload.block !== undefined
                            ? action.payload.block
                            : [],
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                textSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** end text section popup **/

        /** text columns single media section popup **/

        case CLOSE_EDIT_TEXT_SECTION_COLUMNS_SINGLE_MEDIA_POPUP:
            return update(state, {
                textColumnsSingleMediaSectionPopup: {
                    open: {$set: false},
                },
            });

        case OPEN_EDIT_TEXT_SECTION_COLUMNS_SINGLE_MEDIA_POPUP:
            return update(state, {
                textColumnsSingleMediaSectionPopup: {
                    open: {$set: true},
                },
            });

        case DONE_EDIT_TEXT_SECTION_COLUMNS_SINGLE_MEDIA_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    imageSettings: action.payload.imageSettings,
                    videoSettings: action.payload.videoSettings,
                    sectionSettings: action.payload.sectionSettings,
                    locations:
                        typeof action.payload.locations !== undefined
                            ? action.payload.locations
                            : [],
                    block:
                        typeof action.payload.block !== undefined
                            ? action.payload.block
                            : [],
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                textColumnsSingleMediaSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** end text columns single media section popup **/

        /** faqs section **/

        case OPEN_EDIT_FAQS_SECTION_POPUP:
            return update(state, {
                faqsSectionPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_EDIT_FAQS_SECTION_POPUP:
            return update(state, {
                faqsSectionPopup: {
                    open: {$set: false},
                },
            });

        case DONE_EDIT_FAQS_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    settings: action.payload.settings,
                    locations:
                        typeof action.payload.locations !== undefined
                            ? action.payload.locations
                            : [],
                    block:
                        typeof action.payload.block !== undefined
                            ? action.payload.block
                            : [],
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                faqsSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** end faqs section **/

        /** find your project section **/

        case OPEN_EDIT_FIND_YOUR_PROJECT_SECTION_POPUP:
            return update(state, {
                findYourProjectSectionPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_EDIT_FIND_YOUR_PROJECT_SECTION_POPUP:
            return update(state, {
                findYourProjectSectionPopup: {
                    open: {$set: false},
                },
            });

        case DONE_EDIT_FIND_YOUR_PROJECT_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                findYourProjectSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** end find your project section **/

        /** large snippets section **/

        case OPEN_EDIT_LARGE_SNIPPETS_SECTION_POPUP:
            return update(state, {
                largeSnippetsSectionPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_EDIT_LARGE_SNIPPETS_SECTION_POPUP:
            return update(state, {
                largeSnippetsSectionPopup: {
                    open: {$set: false},
                },
            });

        case DONE_EDIT_LARGE_SNIPPETS_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                largeSnippetsSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** end large snippets section **/

        /** value proposition  section **/

        case OPEN_EDIT_VALUE_PROPOSITION_SECTION_POPUP:
            return update(state, {
                valuePropositionSectionPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_EDIT_VALUE_PROPOSITION_SECTION_POPUP:
            return update(state, {
                valuePropositionSectionPopup: {
                    open: {$set: false},
                },
            });

        case DONE_EDIT_VALUE_PROPOSITION_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                valuePropositionSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** end value proposition section **/

        /** promotional boxes section **/

        case OPEN_EDIT_PROMOTIONAL_BOXES_SECTION_POPUP:
            return update(state, {
                promotionalBoxesSectionPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_EDIT_PROMOTIONAL_BOXES_SECTION_POPUP:
            return update(state, {
                promotionalBoxesSectionPopup: {
                    open: {$set: false},
                },
            });

        case DONE_EDIT_PROMOTIONAL_BOXES_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                promotionalBoxesSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** end promotional boxes section **/

        /** meet us section **/

        case OPEN_EDIT_MEET_US_SECTION_POPUP:
            return update(state, {
                meetUsSectionPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_EDIT_MEET_US_SECTION_POPUP:
            return update(state, {
                meetUsSectionPopup: {
                    open: {$set: false},
                },
            });

        case DONE_EDIT_MEET_US_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                meetUsSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** end meet us section **/

        /** trips formats carousel section **/

        case OPEN_EDIT_TRIP_FORMATS_CAROUSEL_SECTION_POPUP:
            return update(state, {
                tripFormatsCarouselSectionPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_EDIT_TRIP_FORMATS_CAROUSEL_SECTION_POPUP:
            return update(state, {
                tripFormatsCarouselSectionPopup: {
                    open: {$set: false},
                },
            });

        case DONE_EDIT_TRIP_FORMATS_CAROUSEL_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                tripFormatsCarouselSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** end trips formats carousel section **/

        /** group trips banner section **/

        case OPEN_EDIT_GROUP_TRIPS_BANNER_SECTION_POPUP:
            return update(state, {
                groupTripsBannerSectionPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_EDIT_GROUP_TRIPS_BANNER_SECTION_POPUP:
            return update(state, {
                groupTripsBannerSectionPopup: {
                    open: {$set: false},
                },
            });

        case DONE_EDIT_GROUP_TRIPS_BANNER_SECTION_POPUP:
            pageToAlter = state.pages[action.payload.pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: action.payload.data,
                    touched: true,
                    deleted: false,
                },
            });

            return update(state, {
                groupTripsBannerSectionPopup: {
                    open: {$set: false},
                },
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        /** end group trips banner section **/

        case SET_PAGE_PREVIEW:
            return update(state, {
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        meta: {
                            preview: {$set: action.payload.preview},
                        },
                    },
                },
            });

        case OPEN_PAGE_PICKER:
            return update(state, {
                sectionPagePickerPopup: {
                    open: {$set: true},
                },
            });

        case CLOSE_PAGE_PICKER:
            return update(state, {
                sectionPagePickerPopup: {
                    open: {$set: false},
                },
            });

        case CHANGE_SECTION_BG_COLOR:
            pageToAlter = state.pages[action.payload.pageId];
            toEditSection = _find(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: action.payload.sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    section_bg_color_id: action.payload.sectionBgColorId,
                },
            });

            return update(state, {
                pages: {
                    [action.payload.pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        case SET_BG_COLORS:
            return update(state, {
                bgColors: {$set: action.payload.bgColors},
            });

        case UPDATE_SECTION:
            const {
                data,
                sectionId,
                pageId,
                locations,
                block,
                settings,
                imageSettings,
                videoSettings,
                sectionSettings,
            } = action.payload;

            pageToAlter = state.pages[pageId];

            toEditSection = _find(pageToAlter.sections, {
                uniqueId: sectionId,
            });
            toEditSectionPosition = _findIndex(pageToAlter.sections, {
                uniqueId: sectionId,
            });

            updatedSection = update(toEditSection, {
                $merge: {
                    data: data,
                    touched: true,
                    deleted: false,
                    locations: locations ? locations : [],
                    block: block ? block : [],
                    settings: settings ? settings : [],
                    sectionSettings: sectionSettings ? sectionSettings : [],
                    imageSettings: imageSettings ? imageSettings : [],
                    videoSettings: videoSettings ? videoSettings : [],
                },
            });

            return update(state, {
                isPopupOpened: {$set: false},
                pages: {
                    [pageId]: {
                        isDirty: {$set: true},
                        sections: {
                            [toEditSectionPosition]: {$set: updatedSection},
                        },
                    },
                },
            });

        case TOGGLE_SECTION_POPUP:
            return update(state, {
                isPopupOpened: {$set: action.payload.isOpen},
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/containers/builder/reducer.js